import React, { Component } from 'react';
import * as microsoftTeams from "@microsoft/teams-js";

import { getGroupByGraphId } from 'actions/groups';
import { Spinner, translate } from '@haldor/ui';
import { connect } from 'react-redux';
import MyAssignmentsWrapper from 'containers/Assignments/MyAssignmentsWrapper';


class AssignmentTabWrapper extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: true,
			group: null,
		};
	}

	componentDidMount() {
		microsoftTeams.app.getContext().then((context) => {
			this.props.getGroupByGraphId(context.team.groupId).then((group) => {
				if (group != null) {
					this.setState({ group: group, groupId: group.id, loading: false });
				} else {
					this.setState({ loading: false });
				}
			});
		});
	}

	render() {
		const { loading } = this.state;

		if (loading) {
			return <Spinner center />;
		}

		return (
			<div>
				<MyAssignmentsWrapper groupId={this.state.group.id} overview={false} />
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		translate: translate(state.Languages.translations),
	};
}

export default connect(mapStateToProps, {
	getGroupByGraphId
})(AssignmentTabWrapper);
